module.exports = __webpack_public_path__ + "img/power_off.a769a1fb.png";